<div class="layout" [class.layout--no-sidebar]="!withSidebar()">
  @if (title()) {
  <div class="layout__header">
    <div>
      <h1>{{ title() }}</h1>
      <p class="layout__header__subtitle">{{ subtitle() }}</p>
    </div>
    <div class="layout__header__actions">
      @if (shareableDeeplink()) {
      <lx-copy-selections-button [valid]="valid()" [copied]="copied()" (copyRequested)="handleCopyRequested()"></lx-copy-selections-button>
      }
    </div>
  </div>
  }
  <div class="layout__main">
    <ng-content select="[layout-main]"></ng-content>
  </div>

  @if (withSidebar()) {
  <div class="layout__sidebar">
    <ng-content select="[layout-sidebar]"></ng-content>
  </div>
  }
</div>
